Namespace 'Process.Methods'
class Process.Methods.ProcessExecutionEventsHandler

  constructor: (@processExecutionView) ->

  handleEvent: (event) =>
    newRelicLogger.logSseEvent(event)
    return if event.account_id != Keepcon.currentAccount.id
    switch event.event_type
      when "ProcessExecutionFinished" then @updateStatus(event)
      when "ProcessExecutionError" then @updateStatus(event)
      when "ProcessExecutionUpdated" then @updateProgress(event)
      when "ProcessExecutionInProgress" then @updateStatus(event)
      when "ProcessExecutionPending" then @updateStatus(event)
      when "ProcessExecutionApprovalResult" then @updateStatus(event)
      else return

  updateProgress: (event) =>
    @processExecutionView.updateProgress(event.process_execution, event.updated_amount)

  updateStatus: (event) =>
    @processExecutionView.updateStatus(event.process_execution)
